import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"
import { WMS2021_R01Content } from "./Content_WMS2021_R01"
import { defaultWMS2021_R01Dto, WMS2021_R01Dto } from "./Dto_WMS2021_R01"
import { SearchSection_WMS2021_R01 } from "./SearchSection_WMS2021_R01"
import { useWMS2021_R01Store } from "./Store_WMS2021_R01"
import { WMS2021_R01Table } from "./Table_WMS2021_R01"
import { InfoSection_WMS2021_R01 } from "./InfoSection_WMS2021_R01"
import { useMouseContent } from "src/utils/mouse/mouseContent"
import { WMS2021_R01DetailTable } from "./DetailTable_WMS2021_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_WMS2021_R01 = () => {
	

	const { 
		WMS2021_R01List,
		insertWMS2021_R01List,
		removeWMS2021_R01List,
		addDeletedWMS2021_R01List,
		allCount,
		initData 
	} = useWMS2021_R01Store();
	const { setMessage } = useUiuxStore();

    const [clickable, setClickable] = useState(true);
	
	const containerRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);
	const gridRef = useRef<AgGridReact<WMS2021_R01Dto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS2021_R01Dto>>(null);

	
	const RESIZER = {
		code: 'WMS2021_R01',
		type: 'height',
		storageKey: 'WMS2021_R01-split-height',
		min: 5,
		max: 80,
		default: 35,
		option: {
			browserMaxHeight: 95
		}
	} as const;

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		buttonDisabled,
		handleExcelClick,
		handlePrintClick,
		defaultWMS2021_R01Row,
		fetchData,
		initContainerData,
		handleDeleteClick,
		handleSaveClick,
	} = WMS2021_R01Content({
		gridRef,
		setMessage,
	});
	
	const {
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
	});
	

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: WMS2021_R01List,
			rowData: {...defaultWMS2021_R01Row(), valueIndex: -1},
			insertRow: insertWMS2021_R01List,
			defaultRowData: defaultWMS2021_R01Row(),
			setClickable
		});
	}, [WMS2021_R01List, insertWMS2021_R01List, setClickable, defaultWMS2021_R01Row]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		
		<SearchSection_WMS2021_R01 />
		<div className="flex-1 flex">
			<div className="flex flex-col flex-1 px-[12px] gap-[4px] p-[10px]"  ref={containerRef} >
				<div className="w-full" style={{ height: `${splitValue}%` }}>
					<WMS2021_R01Table 
						clickable={clickable}				setClickable={setClickable}
						gridRef={gridRef}
					/>
				</div> 
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				<div className="w-full" style={{ height: `${92 - splitValue}%` }}>
					<InfoSection_WMS2021_R01 />
					<WMS2021_R01DetailTable
						clickable={clickable}				setClickable={setClickable}
						gridRef={detailGridRef}
					/>
				</div> 
			</div>
			
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}